/* React */
import React from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { setShowModal } from "src/redux/features/charts/modalSlice";

/* Ionic */
import { IonChip } from "@ionic/react";

/* Utils */
import { mapStatusToColor } from "src/components/admin-dashboard/status-container/helper";

/* Constants */
import { Status } from "src/shared/constants/admin-dashboard/Settings";
import { ModalType } from "src/shared/constants/common/Modal";

/* Stylesheet */
import styles from "./StatusContainer.module.scss";

/* Interfaces */
interface StatusContainerProps {
  status: Status;
}

const StatusContainer: React.FC<StatusContainerProps> = ({
  status,
}) => {
  const dispatch = useDispatch();
  const color = mapStatusToColor(status);

  return status !== Status.DEFAULT ? (
    <>
      <IonChip
        style={{ background: color }}
        className={styles.status}
        onClick={() => {
          dispatch(
            setShowModal({
              modalType: ModalType.DEV_OPTIONS,
              showModal: true,
              className: styles.dev_options,
            })
          );
        }}
      >
        {status}
      </IonChip>
    </>
  ) : undefined;
};

export default StatusContainer;
